import React from "react";
import { Box, Typography } from "@mui/material";

const NoDataAvailable = () => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="250px"
            width="100%"
            sx={{
                color: "#D8A7A7",
                flex: 1,
            }}
        >
            <img
                src="/icons/nodata.png"
                alt="No Data Icon"
                style={{ width: 80, height: 80, marginBottom: 16 }}
            />
            <Typography sx={{ color: "#D8A7A7", fontSize: "1rem" }}>
                No Data Available
            </Typography>
        </Box>
    );
};

export default NoDataAvailable;
